export default __webpack_public_path__ + "static/media/pin-blue.a228e964.svg";